module.exports = __webpack_public_path__ + "static/media/img4.b31b96bd.png";